import React, { useState, useEffect, useContext } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
// import { useAuth } from '../context/AuthContext';
import Logo from "../logo512.png";
import { useTranslation } from "react-i18next";
import "../i18n";
import { baseUrl, getValidAccessToken, mapKnownBackendError, canEditNotes } from "../shared";
import Navbar from "../navbar";
import Navbaranonuser from "../navbaranonuser";
import { AuthContext } from "../context/AuthContext";

// Claude: UAT feedback — "Only administrators and approvers should be able to change the status
// Claude: of a word to accepted or rejected. For r_user, for example, in 'Add a new term', the
// Claude: status should be PND by default. Flagged should be available only to administrators,
// Claude: approvers and editors." Matches _status_change_allowed in views.py, which now actually
// Claude: enforces this server-side too (add_word used to force PENDING no matter what was
// Claude: submitted or by whom — a role-permitted choice is respected now, so this dropdown isn't
// Claude: purely decorative the way it used to be). Any role not listed (including r_user) falls
// Claude: through to the PND-only default a few lines down.
const STATUS_OPTIONS_BY_ROLE = {
  administrator: ["PND", "ACC", "REJ", "FLG"],
  approver: ["PND", "ACC", "REJ", "FLG"],
  editor: ["PND", "FLG"],
};
const STATUS_LABELS = { PND: "pending", ACC: "accepted", REJ: "rejected", FLG: "flagged" };

function AddWord({ isLoggedIn, onLogout }) {
  const { auth } = useContext(AuthContext);

  const { t } = useTranslation();

  //   const { auth } = useAuth();
  const [word, setWord] = useState("");
  const [wordEnglish, setWordEnglish] = useState("");
  const [definition, setDefinition] = useState("");
  const [field, setField] = useState("");
  const [school, setSchool] = useState("");
  const [attribution, setAttribution] = useState("");
  const [status, setStatus] = useState("PND");
  const [pos, setPos] = useState("unknown");
  const [language, setLanguage] = useState("---");
  const [example, setExample] = useState("");
  // Claude: notes field (alpha-tester request) — optional free-form note on the new entry.
  const [notes, setNotes] = useState("");
  const allowedStatusCodes = STATUS_OPTIONS_BY_ROLE[auth.userRole] || ["PND"];
  const [synonyms, setSynonyms] = useState("");
  // Claude: new for UAT feedback — "add a confirmation page to 'add a new term'... with
  // Claude: appropriate next action buttons." Holds the just-created Word (from the backend's
  // Claude: response — see the add_word bugfix in views.py, which used to return the _Template_
  // Claude: row's data instead of the new word's) so "Edit this term" can link to its real _id.
  const [addedWord, setAddedWord] = useState(null);
  const [submitError, setSubmitError] = useState(null);


  // const { auth } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  // Claude: new for specification.md UAT feedback — "Missing terms should include buttons to
  // Claude: initiate appropriate actions." MissingTerms.js links here with ?language=&wordEnglish=
  // Claude: for the specific gap the editor picked, pre-filling the form instead of starting blank.
  useEffect(() => {
    const prefillLanguage = searchParams.get("language");
    const prefillWordEnglish = searchParams.get("wordEnglish");
    if (prefillLanguage) {
      setLanguage(prefillLanguage);
    }
    if (prefillWordEnglish) {
      setWordEnglish(prefillWordEnglish);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // useEffect(() => {
  //   const fetchPhrase = async () => {
  //     const response = await fetch(baseUrl +`v1/addword`);
  //     const data = await response.json();
  //   //   data = data['terms!']
  //   setPhrase(data['terms!']);
  //   setDefinition(data['terms!'][0].definition);
  //   setField(data['terms!'][0].field);
  //   setSchool(data['terms!'][0].school);
  //   setAttribution(data['terms!'][0].attribution);
  //   setStatus(data['terms!'][0].status);
  //   setLanguage(data['terms!'][0].language);
  //   setExample(data['terms!'][0].example);

  // console.log(data,data['terms!'][0],phrase,word,definition,example) };
  //   fetchPhrase();
  // }, [id]);

  function getDate() {
    const today = new Date();
    const month = today.getMonth() + 1;
    const year = today.getFullYear();
    const date = today.getDate();
    return `${year}-${month}-${date}`;
  }

  const handleSubmitWord = async (e) => {
    // Claude: bugfix found during UAT ("check that the new term is actually entered into the
    // Claude: database... my testing picked up a problem there") — this never called
    // Claude: e.preventDefault(), so clicking Add triggered BOTH this handler's fetch() AND the
    // Claude: browser's own native form submission (no action/method on the <form>, so that
    // Claude: defaults to a full-page navigation). That native navigation can abort the in-flight
    // Claude: fetch before the server finishes processing it — a real race, not just a cosmetic
    // Claude: issue, and exactly the kind of intermittent "sometimes it doesn't save" symptom
    // Claude: reported. preventDefault() removes the race entirely.
    e.preventDefault();

    const token = await getValidAccessToken(); // Get valid token

    try {
      const response = await fetch(baseUrl + "v1/addword/", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept":  "application/json",
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({
          word,
          wordEnglish:language === "Eng" ? word : wordEnglish,
          synonyms,
          pos,
          definition,
          example,
          field,
          school,
          language,
          attribution,
          status,
          // Claude: only sent for a role allowed to add notes (see canEditNotes).
          ...(canEditNotes(auth.userRole) ? { notes } : {}),
          "date_edited":getDate(),
          "editor":localStorage.getItem("userName"),
        }),
      });
      const data = await response.json();
      if (response.ok) {
        setSubmitError(null);
        // Claude: data is now the actual created Word (see the add_word bugfix in views.py) —
        // Claude: drives the confirmation page below, including "Edit this term"'s link.
        setAddedWord(data);
      } else {
        setSubmitError(mapKnownBackendError(t, data.error) || t("failed_to_add_term"));
      }
    } catch (error) {
      console.error("Error:", error);
      setSubmitError(t("something_went_wrong_adding_term"));
    }
  };

  // Claude: new for UAT feedback — resets the form to add another term after a successful
  // Claude: submission, rather than the previous navigate(0) full-page reload (which discarded
  // Claude: any confirmation of what had just happened).
  const resetForAnotherTerm = () => {
    setAddedWord(null);
    setSubmitError(null);
    setWord("");
    setWordEnglish("");
    setDefinition("");
    setField("");
    setSchool("");
    setAttribution("");
    setStatus("PND");
    setPos("unknown");
    setLanguage("---");
    setExample("");
    setNotes("");
    setSynonyms("");
  };

  return (
    <div className="min-h-screen bg-gray-100">
      {/* <Navbar /> */}
      {/* {auth.userRole === "editor" && <Navbar />}
      {auth.userRole !== "editor" && <Navbaranonuser />} */}
      {localStorage.setItem("bladsy", "Addword")}
      {auth.userName === null && <Navbaranonuser />}
      {auth.userName != null && <Navbar />}
      <div className="flex flex-col justify-center items-center p-3">
        <h2 className="text-3xl font-bold mb-2">{t("add")}</h2>
        {/* <h2 className="text-2xl mb-4">Add New Phrase</h2> */}
        {/* Claude: new for UAT feedback — "add a confirmation page to 'add a new term'... not to
            ask for confirmation, but to confirm that the term was added, with appropriate next
            action buttons." Replaces the form with a confirmation view after a successful submit
            (addedWord set — see handleSubmitWord/resetForAnotherTerm above), matching the
            isSubmitted-swap pattern NoResultsModal.js already uses for its own success state. */}
        {addedWord ? (
          <div className="w-full max-w-3xl bg-white rounded-lg shadow-lg p-6 text-center">
            <p className="text-xl mb-6">{t("term_added", { word: addedWord.word })}</p>
            <div className="flex flex-col gap-3 items-center">
              <button
                onClick={resetForAnotherTerm}
                className="w-full max-w-xs bg-cyan-700 text-white py-2 px-4 rounded-lg hover:bg-cyan-800"
              >
                {t("add_another_term")}
              </button>
              {/* Claude: only offered to roles update_word actually permits (IsEditor | IsApprover
                  | IsAdministrator in views.py) — an r_user can add terms but not edit them. */}
              {(auth.userRole === "editor" || auth.userRole === "approver" || auth.userRole === "administrator") && (
                <button
                  onClick={() => navigate(`/update/${addedWord._id}`)}
                  className="w-full max-w-xs bg-gray-700 text-white py-2 px-4 rounded-lg hover:bg-gray-800"
                >
                  {t("edit_this_term")}
                </button>
              )}
            </div>
          </div>
        ) : (
        <div className="w-full max-w-3xl bg-white rounded-lg shadow-lg p-6 justify-center">
          {submitError && <p className="text-rose-700 mb-4">{submitError}</p>}
          <form
            onSubmit={handleSubmitWord}
            className="bg-white p-8 rounded shadow-lg"
          >
            <div className="mb-4">
              <label className="block text-gray-700">
                <strong>{t("word")}:</strong>
              </label>
              <input
                type="text"
                value={word}
                onChange={(e) => {setWord(e.target.value);
                }}
                className="border p-2 w-full"
              />
            </div>
            <div className="mb-4">
              <label className="block text-gray-700">
                <strong>{t("synonyms")}:</strong>
              </label>
              <input
                type="text"
                value={synonyms}
                onChange={(e) => {setSynonyms(e.target.value);
                }}
                className="border p-2 w-full"
              />
            </div>
            <div className="mb-4">
              <label className="block text-gray-700">
                <strong>{t("language")}:</strong>
              </label>
              <select
                value={language}
                onChange={(e) => {setLanguage(e.target.value);
                  // if (language === "Eng" || language === "---" || language === ""){
                  //   setWordEnglish(word);
                  // }{}
                }}
                className="border p-2 w-full"
              >
                <option value="---">---</option>
                <option value="Eng">English</option>
                <option value="Afr">Afrikaans</option>
                <option value="Zul">isiZulu</option>
                <option value="Ses">Sesotho</option>
                <option value="Sep">Sepedi</option>
                <option value="Set">Setswana</option>
                <option value="Xit">Xitsonga</option>
                <option value="Sis">siSwati</option>
                <option value="Nde">isiNdebele</option>
                <option value="Xho">isiXhosa</option>
                <option value="Tsh">Tshivenḓa</option>
                <option value="Por">Portuguese</option>
                <option value="Fre">French</option>
              </select>
            </div>
            {language != "Eng" && (
              <div className="mb-4">
                <label className="block text-gray-700">
                  <strong>{t("english_translation")}</strong>
                </label>
                <input
                  type="text"
                  value={wordEnglish}
                  onChange={(e) => setWordEnglish(e.target.value)}
                  className="border p-2 w-full"
                />
              </div>
            )}
            <div className="mb-4">
              <label className="block text-gray-700">
                <strong>{t("pos")}:</strong>
              </label>
              <select
                value={pos}
                onChange={(e) => {
                  setPos(e.target.value);
                }}
                className="border p-2 w-full"
              >
                <option value="Unknown">{t("unknown")}</option>
                <option value="Noun">{t("noun")}</option>
                <option value="Verb">{t("verb")}</option>
                <option value="Adjective">{t("adjective")}</option>
                <option value="Pronoun">{t("pronoun")}</option>
                <option value="Adverb">{t("adverb")}</option>
                <option value="Preposition">{t("preposition")}</option>
                <option value="Conjunction">{t("conjunction")}</option>
                <option value="Article">{t("article")}</option>
                <option value="Interjection">{t("interjection")}</option>
              </select>
              </div>
            <div className="mb-4">
              <label className="block text-gray-700">
                <strong>{t("definition")}:</strong>
              </label>
              <input
                type="text"
                value={definition}
                onChange={(e) => setDefinition(e.target.value)}
                className="border p-2 w-full"
              />
            </div>
            <div className="mb-4">
              <label className="block text-gray-700">
                <strong>{t("example")}:</strong>
              </label>
              <input
                type="text"
                value={example}
                onChange={(e) => setExample(e.target.value)}
                className="border p-2 w-full"
              />
            </div>
            {/* Claude: notes field (alpha-tester request) — free-form, multi-line, optional;
                editors/approvers/administrators only (registered users may only read notes). */}
            {canEditNotes(auth.userRole) && (
              <div className="mb-4">
                <label htmlFor="add-notes" className="block text-gray-700">
                  <strong>{t("notes")}:</strong>
                </label>
                <textarea
                  id="add-notes"
                  rows={3}
                  value={notes}
                  onChange={(e) => setNotes(e.target.value)}
                  aria-describedby="add-notes-hint"
                  className="border p-2 w-full"
                />
                <p id="add-notes-hint" className="text-sm text-gray-500">{t("notes_hint")}</p>
              </div>
            )}
            <div className="mb-4">
              <label className="block text-gray-700">
                <strong>{t("context")}:</strong>
              </label>
              <input
                type="text"
                value={field}
                onChange={(e) => setField(e.target.value)}
                className="border p-2 w-full"
              />
            </div>
            <div className="mb-4">
              <label className="block text-gray-700">
                <strong>{t("school")}:</strong>
              </label>
              <input
                type="text"
                value={school}
                onChange={(e) => setSchool(e.target.value)}
                className="border p-2 w-full"
              />
            </div>
            <div className="mb-4">
              <label className="block text-gray-700">
                <strong>{t("attribution")}:</strong>
              </label>
              <input
                type="text"
                value={attribution}
                onChange={(e) => setAttribution(e.target.value)}
                className="border p-2 w-full"
              />
            </div>
            <div className="mb-4">
              <label className="block text-gray-700">
                <strong>{t("status")}:</strong>
              </label>
              {/* Claude: UAT feedback — an r_user (or any other role only permitted PND) has
                  nothing to actually choose, so showing a dropdown with a single working option
                  would be misleading; a plain read-only value makes that clear instead. */}
              {allowedStatusCodes.length > 1 ? (
                <select
                  value={status}
                  onChange={(e) => {
                    setStatus(e.target.value);
                    if (language == "Eng") {
                      setWordEnglish(word);
                      console.log(word);
                      console.log("wordenglish...", wordEnglish);
                    }
                  }}
                  className="border p-2 w-full"
                >
                  {allowedStatusCodes.map((code) => (
                    <option key={code} value={code}>{t(STATUS_LABELS[code])}</option>
                  ))}
                </select>
              ) : (
                <p className="border p-2 w-full bg-gray-50 text-gray-700">{t(STATUS_LABELS.PND)}</p>
              )}
            </div>
            {/*         
        <div className="mb-4">
          <label className="block text-gray-700"><strong>Status:</strong></label>
          <input
            type="text"
            value={status}
            onChange={(e) => {setStatus(e.target.value);
              if (language == "Eng"){
                setWordEnglish(word);  
                console.log(word);
                console.log("wordenglish...",wordEnglish)
                };
              if (language == "Eng"){
                setWordEnglish(word);  
                console.log(word);
                console.log("wordenglish...",wordEnglish)
                }}
            }
            className="border p-2 w-full"
          />          
        </div> */}
            <button
              type="submit"
              className="w-full bg-cyan-700 text-white py-2 px-4 rounded-lg hover:bg-cyan-800"
            >
              {t("add")}
            </button>
            <button
              type="reset"
              onClick={(e) => {
                // setWord(word);
                // setDefinition(definition);
                // setExample(example);
                window.history.back();
              }}
              className="w-1/2 mt-6 bg-rose-700 text-white py-2 px-4 rounded-lg hover:bg-rose-800"
            >
              {t("cancel")}
            </button>
          </form>
        </div>
        )}
        <div className="flex flex-col justify-center items-center p-4">
          <Link to={"/"}>
            <img src={Logo} alt="Logo" width="100" height="100" />
          </Link>
        </div>
      </div>
    </div>
  );
}

export default AddWord;
